import { Typography, Card, CardMedia, Box, useTheme } from "@mui/material";

import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import ArrowRightIcon from "@/assets/icons/arrow-long-right.svg?react";
import ButtonWithIcon from "@/components/UI-Kit/ButtonWithIcon";

interface IProps {
  title: string;
  description: string;
  iconUrl: string;
}

const TroubleshootingCard: React.FC<IProps> = ({
  title,
  description,
  iconUrl,
}) => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "sm");

  return (
    <Card
      variant="outlined"
      sx={{
        border: "none",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap: `${isMobile ? theme.spacing(3) : theme.spacing(4)}`,
      }}
    >
      {/* Image */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: "auto",
          height: { xs: 153, sm: 259 },
          boxSizing: "border-box",
          bgcolor: "background.default",
          borderRadius: "20px",
        }}
      >
        <CardMedia
          component="img"
          image={iconUrl}
          alt={title}
          sx={{
            width: { xs: 60, md: 100 },
            height: { xs: 60, md: 100 },
          }}
        />
      </Box>

      {/* Description */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "start",
        }}
      >
        <Box>
          <Typography
            variant="h4"
            component="h3"
            color="text.primary"
            mb={`${isMobile ? theme.spacing(1) : theme.spacing(2)}`}
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            fontSize={{ sm: 16, md: 18 }}
            mb={isMobile ? theme.spacing(1.5) : theme.spacing(2.5)}
          >
            {description}
          </Typography>
        </Box>
        <ButtonWithIcon
          label="Solution"
          IconComponent={ArrowRightIcon}
          isLink={true}
          to={ROUTES.articleDetails}
        />
      </Box>
    </Card>
  );
};

export default TroubleshootingCard;
